import { render, staticRenderFns } from "./GridNote.vue?vue&type=template&id=fa29a3c0&"
import script from "./GridNote.vue?vue&type=script&lang=js&"
export * from "./GridNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports